import {
    Inject,
    ISimpleControllerConfiguration, MultiStyleText,
    SimpleBaseController
} from "@denishussar/html5-game-engine";
import {GameModel} from "./Models/GameModel";

export interface IVersionControllerOptions
{
    version:string
}

export class VersionController extends SimpleBaseController {
    $model: GameModel;
    private _versionLabel: MultiStyleText;

    public constructor(@Inject private _options:IVersionControllerOptions) {
        super("VersionController");
    }

    protected getConfiguration(): ISimpleControllerConfiguration {

        return <ISimpleControllerConfiguration>{
            childControllers: {

            }
        };
    }

    protected onInitialize(): void {
        this._versionLabel = new MultiStyleText("v." + this._options.version, <any>{
            "default": {
                fontSize: 32,
                fill : 0xffffff,
                align : "center",
                stroke : 1,
                strokeThickness : 2
            },
            "b": {
                fontFamily : 'Bold'
            }
        });
        this._versionLabel.anchor = new PIXI.ObservablePoint(null, null,  0, 1);
        this._versionLabel.alpha = .2;
        this.display.addChild(this._versionLabel);
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onResize(width: number, height: number, scale: number): void {
        this.y = height/scale/2;
        this.x = -width/scale/2;
    }
}
